{
    "of": "of",
    "replaces": "replaces"
}
